// GİB UBL-TR e-Fatura/e-Arşiv XSLT'leri VERİ ODAKLIDIR: alanlar ve kalemler gerçek
// fatura XML'i şablona uygulanınca (apply-templates/call-template) oluşur. Kullanıcı yalnız
// XSLT yüklediğinde, şablonu bu KANONİK ÖRNEK UBL faturasına uygulayıp tam yapıyı (başlık
// alanları + 2 kalem satırı + toplamlar) elde ederiz. Örnek değerler jeneriktir; içe aktarım
// alanları Türkçe başlık/etiket metnine göre bizim alanlarımıza bağlar.
export const SAMPLE_UBL_INVOICE = String.raw`
<?xml version="1.0" encoding="UTF-8"?>
<n1:Invoice
  xmlns:n1="urn:oasis:names:specification:ubl:schema:xsd:Invoice-2"
  xmlns:cac="urn:oasis:names:specification:ubl:schema:xsd:CommonAggregateComponents-2"
  xmlns:cbc="urn:oasis:names:specification:ubl:schema:xsd:CommonBasicComponents-2"
  xmlns:ext="urn:oasis:names:specification:ubl:schema:xsd:CommonExtensionComponents-2">
  <cbc:UBLVersionID>2.1</cbc:UBLVersionID>
  <cbc:CustomizationID>TR1.2</cbc:CustomizationID>
  <cbc:ProfileID>EARSIVFATURA</cbc:ProfileID>
  <cbc:ID>ABC2024000000123</cbc:ID>
  <cbc:CopyIndicator>false</cbc:CopyIndicator>
  <cbc:UUID>11111111-2222-3333-4444-555555555555</cbc:UUID>
  <cbc:IssueDate>2024-06-26</cbc:IssueDate>
  <cbc:IssueTime>10:30:00</cbc:IssueTime>
  <cbc:InvoiceTypeCode>SATIS</cbc:InvoiceTypeCode>
  <cbc:Note>Aciklama notu satiri</cbc:Note>
  <cbc:DocumentCurrencyCode>TRY</cbc:DocumentCurrencyCode>
  <cbc:LineCountNumeric>2</cbc:LineCountNumeric>
  <cac:Signature>
    <cbc:ID schemeID="VKN_TCKN">1234567801</cbc:ID>
  </cac:Signature>
  <cac:AccountingSupplierParty>
    <cac:Party>
      <cbc:WebsiteURI>www.satici.com</cbc:WebsiteURI>
      <cac:PartyIdentification><cbc:ID schemeID="VKN">1234567801</cbc:ID></cac:PartyIdentification>
      <cac:PartyName><cbc:Name>SATICI ANONIM SIRKETI</cbc:Name></cac:PartyName>
      <cac:PostalAddress>
        <cbc:StreetName>Satici Caddesi No 10</cbc:StreetName>
        <cbc:CitySubdivisionName>Kadikoy</cbc:CitySubdivisionName>
        <cbc:CityName>Istanbul</cbc:CityName>
        <cbc:PostalZone>34000</cbc:PostalZone>
        <cac:Country><cbc:Name>Turkiye</cbc:Name></cac:Country>
      </cac:PostalAddress>
      <cac:PartyTaxScheme><cac:TaxScheme><cbc:Name>Kadikoy</cbc:Name></cac:TaxScheme></cac:PartyTaxScheme>
      <cac:Contact>
        <cbc:Telephone>0216 000 00 00</cbc:Telephone>
        <cbc:ElectronicMail>satici@satici.com</cbc:ElectronicMail>
      </cac:Contact>
    </cac:Party>
  </cac:AccountingSupplierParty>
  <cac:AccountingCustomerParty>
    <cac:Party>
      <cac:PartyIdentification><cbc:ID schemeID="TCKN">12345678901</cbc:ID></cac:PartyIdentification>
      <cac:PartyName><cbc:Name>ALICI MUSTERI LTD STI</cbc:Name></cac:PartyName>
      <cac:PostalAddress>
        <cbc:StreetName>Alici Sokak No 5</cbc:StreetName>
        <cbc:CitySubdivisionName>Cankaya</cbc:CitySubdivisionName>
        <cbc:CityName>Ankara</cbc:CityName>
        <cac:Country><cbc:Name>Turkiye</cbc:Name></cac:Country>
      </cac:PostalAddress>
      <cac:PartyTaxScheme><cac:TaxScheme><cbc:Name>Cankaya</cbc:Name></cac:TaxScheme></cac:PartyTaxScheme>
      <cac:Contact>
        <cbc:Telephone>0312 000 00 00</cbc:Telephone>
        <cbc:ElectronicMail>alici@alici.com</cbc:ElectronicMail>
      </cac:Contact>
    </cac:Party>
  </cac:AccountingCustomerParty>
  <cac:PaymentMeans>
    <cbc:PaymentMeansCode>1</cbc:PaymentMeansCode>
    <cac:PayeeFinancialAccount><cbc:ID>TR000000000000000000000000</cbc:ID></cac:PayeeFinancialAccount>
  </cac:PaymentMeans>
  <cac:TaxTotal>
    <cbc:TaxAmount currencyID="TRY">36.00</cbc:TaxAmount>
    <cac:TaxSubtotal>
      <cbc:TaxableAmount currencyID="TRY">200.00</cbc:TaxableAmount>
      <cbc:TaxAmount currencyID="TRY">36.00</cbc:TaxAmount>
      <cbc:Percent>18</cbc:Percent>
      <cac:TaxCategory><cac:TaxScheme><cbc:Name>KDV</cbc:Name><cbc:TaxTypeCode>0015</cbc:TaxTypeCode></cac:TaxScheme></cac:TaxCategory>
    </cac:TaxSubtotal>
  </cac:TaxTotal>
  <cac:LegalMonetaryTotal>
    <cbc:LineExtensionAmount currencyID="TRY">200.00</cbc:LineExtensionAmount>
    <cbc:TaxExclusiveAmount currencyID="TRY">200.00</cbc:TaxExclusiveAmount>
    <cbc:TaxInclusiveAmount currencyID="TRY">236.00</cbc:TaxInclusiveAmount>
    <cbc:AllowanceTotalAmount currencyID="TRY">0.00</cbc:AllowanceTotalAmount>
    <cbc:PayableAmount currencyID="TRY">236.00</cbc:PayableAmount>
  </cac:LegalMonetaryTotal>
  <cac:InvoiceLine>
    <cbc:ID>1</cbc:ID>
    <cbc:InvoicedQuantity unitCode="C62">2</cbc:InvoicedQuantity>
    <cbc:LineExtensionAmount currencyID="TRY">100.00</cbc:LineExtensionAmount>
    <cac:AllowanceCharge><cbc:MultiplierFactorNumeric>0</cbc:MultiplierFactorNumeric><cbc:Amount currencyID="TRY">0.00</cbc:Amount></cac:AllowanceCharge>
    <cac:TaxTotal>
      <cbc:TaxAmount currencyID="TRY">18.00</cbc:TaxAmount>
      <cac:TaxSubtotal><cbc:Percent>18</cbc:Percent><cbc:TaxAmount currencyID="TRY">18.00</cbc:TaxAmount>
        <cac:TaxCategory><cac:TaxScheme><cbc:Name>KDV</cbc:Name></cac:TaxScheme></cac:TaxCategory></cac:TaxSubtotal>
    </cac:TaxTotal>
    <cac:Item>
      <cbc:Name>BIRINCI URUN ADI</cbc:Name>
      <cac:SellersItemIdentification><cbc:ID>STK-001</cbc:ID></cac:SellersItemIdentification>
    </cac:Item>
    <cac:Price><cbc:PriceAmount currencyID="TRY">50.00</cbc:PriceAmount></cac:Price>
  </cac:InvoiceLine>
  <cac:InvoiceLine>
    <cbc:ID>2</cbc:ID>
    <cbc:InvoicedQuantity unitCode="C62">1</cbc:InvoicedQuantity>
    <cbc:LineExtensionAmount currencyID="TRY">100.00</cbc:LineExtensionAmount>
    <cac:AllowanceCharge><cbc:MultiplierFactorNumeric>0</cbc:MultiplierFactorNumeric><cbc:Amount currencyID="TRY">0.00</cbc:Amount></cac:AllowanceCharge>
    <cac:TaxTotal>
      <cbc:TaxAmount currencyID="TRY">18.00</cbc:TaxAmount>
      <cac:TaxSubtotal><cbc:Percent>18</cbc:Percent><cbc:TaxAmount currencyID="TRY">18.00</cbc:TaxAmount>
        <cac:TaxCategory><cac:TaxScheme><cbc:Name>KDV</cbc:Name></cac:TaxScheme></cac:TaxCategory></cac:TaxSubtotal>
    </cac:TaxTotal>
    <cac:Item>
      <cbc:Name>IKINCI URUN ADI</cbc:Name>
      <cac:SellersItemIdentification><cbc:ID>STK-002</cbc:ID></cac:SellersItemIdentification>
    </cac:Item>
    <cac:Price><cbc:PriceAmount currencyID="TRY">100.00</cbc:PriceAmount></cac:Price>
  </cac:InvoiceLine>
</n1:Invoice>
`;
